'use client';

import type { FC } from 'react';
import { BottomSheet } from '../../components/ui';
import { useLocalTranslation } from '../../hooks/useLocalTranslation';
import { ShopFiltersPanel, type FilterValues } from './ShopFiltersPanel';
import translations from './ShopScreen.translations';

interface FilterModalProps {
  isOpen: boolean;
  filters: FilterValues;
  onApply: (filters: FilterValues) => void;
  onClose: () => void;
}

export const FilterModal: FC<FilterModalProps> = ({ isOpen, filters, onApply, onClose }) => {
  const { t } = useLocalTranslation(translations);

  const handleApply = (newFilters: FilterValues) => {
    onApply(newFilters);
    onClose();
  };

  return (
    <BottomSheet isOpen={isOpen} onClose={onClose} title={t('showFilters')} heightClass="h-auto max-h-[85vh]">
      <div className="pt-1">
        <ShopFiltersPanel filters={filters} onApply={handleApply} />
      </div>
    </BottomSheet>
  );
};
